/** Placeholder rows while the first data loads. */
export function SkeletonList({ rows = 3 }: { rows?: number }) {
  return (
    <ul className="habit-list" aria-busy="true" aria-label="Wird geladen">
      {Array.from({ length: rows }, (_, i) => (
        <li key={i} className="skeleton glass" style={{ animationDelay: `${i * 0.12}s` }} />
      ))}
    </ul>
  );
}
